import React from 'react';
import {CategoryOption} from "../../theme/forms/SelectByCategory"


export default class LoanEstimateShareModal extends React.PureComponent{

    constructor(props) {
        super(props);

        this.state = {
            share_options: false,
            selected_options: [],
            copied: false
        }
    }

    componentDidMount() {
        if (this.props.specOptionId.length != 0) {
            this.setState({
                selected_options: this.props.specOptionId,
                share_options: true
            })
        }
    }


    getOptionTitle = (option, optionArray) => {
        if (option?.title) {
            return this.props.title
        } else {
            let type_index = optionArray.reduce((r,d,i,a) =>  {
                if (r.arrived) return r;
                if (d.product.type === option.product.type) {
                    r.index += 1;
                }
                if (d.id === option.id) {
                    r.arrived = true
                }
                return r;
            }, {arrived: false, index: 0})
            return `${option.product.type} Option ${type_index.index}`
        }
    }

    getLink = () => {
        if (!this.state.share_options) {
            return `https://${window.location.host}/share-estimate/?g=${this.props.data.id}`
        } else {
            let url_str = this.state.selected_options.join('|')
            return `https://${window.location.host}/share-estimate/?o=${url_str}`
        }
    }

    renderOptionsForLink = () => {
        let {estimates} = this.props.data;
        return estimates.map((d,i,a) => {
            return (
                <CategoryOption
                    optionData={{...d,
                        title: this.getOptionTitle(d, a),
                        selected: (this.state.selected_options || []).includes(d.id)
                    }}
                    displayKey={'title'}
                    dataKey={'id'}
                    centered={true}
                    onOptionValueChange={this.props.onOptionValueChange}
                />
            )
        })
    }

    render() {
        return (
            <div className={`modal ${this.props.visible ? 'is-active' : ''}`}>
                <div className="modal-background"/>
                <div className="modal-card">
                    <header className="modal-card-head has-background-success-light justify-center">
                        Copy this link to share.
                    </header>
                    {this.state.share_options ?
                        <section className={"modal-card-body px-6"}>
                            <h6 className={'is-size-6 mb-3 has-text-weight-semibold'}>Select Options to Share</h6>
                            {this.renderOptionsForLink()}
                        </section> :
                        <section className={"modal-card-body px-6 pb-0"}>
                            <p>This link shares all available options. Share directly from an option tile if you just want to share one or a few.</p>
                        </section>
                    }
                    <section className="modal-card-body">
                        <div className={'is-flex  is-justify-content-space-evenly is-align-content-center my-4'}>
                            <div className={'title is-6 has-text-primary'}>{this.getLink()}</div>
                        </div>
                        <div className="buttons mt-5 is-justify-content-center">
                            <div className={`button mr-3 ${this.state.copied ? 'is-success': 'is-outlined'}`}
                                 onClick={() => {
                                     navigator.clipboard.writeText(this.getLink())
                                         .then(() => {
                                             this.setState({copied: true},
                                                 () => setTimeout(() => this.setState({copied: false}), 1000)
                                             )
                                         })
                                 }}>
                                {this.state.copied ? 'Copied!' : 'Copy Link'}
                            </div>
                            <button
                                className={`button is-primary`}
                                onClick={this.props.onAccept}
                            >{this.props.acceptButtonText || 'OK'}</button>
                        </div>
                    </section>
                    {/*<footer className="modal-card-foot has-background-white">*/}

                    {/*</footer>*/}
                </div>
            </div>
        )
    }

}
